export default __webpack_public_path__ + "static/media/shopping-cart.9c468cd7.svg";